import { action, ActionType } from "typesafe-actions";

import { Nullable } from "../../../../types/common";
import { IError } from "../../../../redux/actions/errorHandlingAction";
import { TWorkOrderResults } from "../../../../redux/reducers/workOrdersReducer";
import { SearchResults } from "../../../../types/search/search-results.interface";

export enum ExecutionBriefWorkOrdersActions {
  FetchWorkOrders = "ExecutionBrief/FetchWorkOrders",
  FetchWorkOrdersFailure = "ExecutionBrief/FetchWorkOrdersFailure",
  FetchWorkOrdersSuccess = "ExecutionBrief/FetchWorkOrdersSuccess",
}

export const fetchWorkOrders = () => action(ExecutionBriefWorkOrdersActions.FetchWorkOrders);
export const fetchWorkOrdersFailure = (error: Nullable<IError>) =>
  action(ExecutionBriefWorkOrdersActions.FetchWorkOrdersFailure, error);
export const fetchWorkOrdersSuccess = (results: SearchResults<TWorkOrderResults>) =>
  action(ExecutionBriefWorkOrdersActions.FetchWorkOrdersSuccess, results);

const actionCreators = {
  fetchWorkOrders,
  fetchWorkOrdersFailure,
  fetchWorkOrdersSuccess,
};

export type ExecutionBriefWorkOrdersActionTypes = ActionType<typeof actionCreators>;
